import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(undefined, async (error) => {
  const { config, response } = error;
  const url = config?.url || "";
  const detail = response?.data?.detail || "";
  const authPath = url.includes("/auth/login") || url.includes("/auth/refresh") || url.includes("/auth/me") || url.includes("/auth/logout");
  if (response?.status === 401 && !config._retried && !authPath && !config?._silent401 && /expired|revoked|Not authenticated/i.test(detail)) {
    config._retried = true;
    try {
      refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
      await refreshing;
      return api(config);
    } catch {
      if (!window.location.pathname.startsWith("/login")) window.location.href = `/login?next=${encodeURIComponent(window.location.pathname)}`;
    }
  }
  return Promise.reject(error);
});

export function errText(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d?.msg || String(d);
}

export const money = (v, cur = "$") => {
  const n = Number(v || 0);
  return (n < 0 ? "-" : "") + cur + Math.abs(n).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};
export const pct = (v, d = 1) => `${Number(v || 0).toFixed(d)}%`;
export const fmtDate = (s) => (s ? String(s).slice(0, 16).replace("T", " ") : "—");
